// English strings for Reports → Kitchen flow (Stage 3). One table so an Urdu
// one can be dropped in later.
export const FR = {
  tab: 'Kitchen flow',
  sections: {
    avt: 'Kitchen check',
    requests: 'Store requests',
    transit: 'Lost in transit',
    cooking: 'Cooking yield',
    stock: 'Stock by place',
    buying: 'Buying',
    counts: 'Counts',
  } as Record<string, string>,
  loading: 'Loading…',
  failed: 'Could not load this report.',
  empty: 'Nothing in these dates.',
  exportExcel: 'Download Excel',
  exporting: 'Downloading…',
  exportFailed: 'Download failed. Please try again.',
  avt: {
    title: 'Kitchen: what was used vs what should have been',
    explain: 'Between two counts of the kitchen: what was there, plus what came in, less what orders, events and cooking used, should be on the shelf. The dates choose which two counts to compare.',
    firstCount: 'Count the kitchen once to start the check (Production → Count the kitchen).',
    countAgain: 'Count the kitchen again to compare with your last count.',
    headlineMissing: (value: string, from: string, to: string) => `${value} of stock can't be explained between your counts on ${from} and ${to}`,
    biggest: (item: string, qty: string, value: string) => ` — biggest: ${item} ${qty} (${value})`,
    headlineClean: (from: string, to: string) => `Nothing is missing between your counts on ${from} and ${to}.`,
    missingTotal: 'Missing',
    extraTotal: 'Extra on the shelf',
    extraHint: 'More than the records explain — usually a miscount or a delivery not entered.',
    noRecipe: (n: number) => (n === 1 ? '1 dish sold without a recipe (its ingredients look missing)' : `${n} dishes sold without a recipe (their ingredients look missing)`),
    noRecipeFix: 'Add a recipe to each so its ingredients come off the books when it sells.',
    notWrapped: (n: number) => (n === 1 ? '1 event not wrapped up in these dates' : `${n} events not wrapped up in these dates`),
    notWrappedFix: 'Wrap up each event (Production → Plans) so what the dishes used is recorded.',
    seeAll: 'See every item',
    place: 'Place',
    wasteNotRecorded: 'Waste not recorded yet — anything thrown away shows as unexplained or "other out".',
    unexplainedValue: 'Unexplained',
    ofUsage: (pct: string) => `${pct}% of what was used`,
    withCounts: 'Items counted at both ends',
    missingCounts: 'Items without a count (no figure)',
    status: {
      ok: '',
      no_counts: 'Not counted',
      no_opening_count: 'No opening count',
      no_closing_count: 'No closing count',
    } as Record<string, string>,
    cols: ['Item', 'Opening', 'Received', 'Made', 'Used by orders & events', 'Used in cooking', 'Waste', 'Other changes', 'Expected', 'Counted', 'Unexplained', 'Value'],
    chart: 'Biggest unexplained (by value)',
    notRecorded: 'not recorded',
    missing: 'missing',
    extra: 'extra',
    howToCount: 'Count the kitchen at the start and end of the dates (Production → Count the kitchen) to see this.',
  },
  requests: {
    title: 'Did the kitchen get what it asked for?',
    requests: (n: number) => (n === 1 ? '1 request' : `${n} requests`),
    byPlace: 'By place',
    byItem: 'By item',
    timing: 'How long each step takes',
    steps: { approve: 'Sent → approved', issue: 'Approved → sent out', receive: 'Sent out → received', total: 'Asked → received' } as Record<string, string>,
    median: 'Typical',
    p90: 'Slowest 1 in 10',
    cols: ['', 'Asked', 'Approved', 'Sent', 'Received', 'Received %'],
    placeCols: ['', 'Requests', 'Items asked', 'Sent %', 'Received %'],
    placeHint: 'Per place, each item counts the same (kg and pieces are never added together).',
  },
  transit: {
    title: 'Stock that went missing between the store and the kitchen',
    total: 'Total missing',
    byPerson: 'Who sent and who received',
    pair: (sent: string, received: string) => `Sent by ${sent} → received by ${received}`,
    nobody: 'not recorded',
    cases: (n: number) => (n === 1 ? '1 case' : `${n} cases`),
    lines: 'Each case',
    cols: ['Request', 'Item', 'Missing', 'Written off', 'Value', 'Sent by', 'Received by', 'PIN by', 'Reason'],
    stillOut: 'still in transit',
  },
  cooking: {
    title: 'Did batches make what they should?',
    byItem: 'By prep item',
    byCook: 'By cook',
    cols: ['', 'Batches', 'Planned', 'Made', 'Difference', '%', 'Under'],
  },
  stock: {
    title: 'What each place holds',
    asOf: (d: string) => `As of ${d}`,
    value: 'Value',
    items: (n: number) => `${n} items`,
    slow: (n: number) => `${n} slow`,
    dead: (n: number) => `${n} not used in 30 days`,
    expiring: 'Expiring soon (use first)',
    expiryCols: ['Place', 'Item', 'Lot', 'Expires', 'Days left', 'Qty', 'Value'],
    cols: ['Item', 'Qty', 'Value', 'Used / day', 'Days on hand', ''],
    status: { ok: '', slow: 'Slow', dead: 'Not used', negative: 'Below zero' } as Record<string, string>,
    noExpiry: 'Nothing expiring in the next days.',
  },
  buying: {
    title: 'Prices paid and how suppliers deliver',
    priceTitle: 'Price changes',
    varianceTotal: 'Paid above earlier prices',
    priceCols: ['Item', 'Bought', 'Before', 'Average', 'Last', 'Change', 'Extra paid', 'Supplier'],
    vendorTitle: 'Suppliers',
    vendorCols: ['Supplier', 'Orders', 'Delivered %', 'On time', 'Overdue now'],
    firstPrice: 'first price',
    onTime: (a: number, b: number) => `${a} of ${b}`,
  },
}
